import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

export interface ErrorDetails {
  message: string;
  error?: string;
  error_description?: string;
  timestamp: Date;
}

@Component({
  selector: 'app-generic-error-display',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './generic-error-display.component.html',
  styleUrl: './generic-error-display.component.scss'
})
export class GenericErrorDisplayComponent implements OnInit {
  errors: ErrorDetails[] = [];

  constructor(private router: Router) {}

  ngOnInit(): void {
    // Get errors from navigation state
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state || history.state;

    if (state?.['errors']) {
      this.errors = state['errors'];
    } else if (state?.['error']) {
      // Handle single error
      this.errors = [state['error']];
    }

    // If no errors, redirect to home
    if (this.errors.length === 0) {
      this.router.navigate(['/']);
    }
  }

  goToHome(): void {
    this.router.navigate(['/']);
  }
}
